// blog comment data

export const commentsData = [
  {
    imageUrl: "assets/images/blog/blog-comment.jpg",
    author: "Lorem Ipsum Is Simply Dummy",
    content: "Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.Donec sed odio dui.",
  },
  {
    imageUrl: "assets/images/blog/blog-comment-two.jpg",
    author: "Lorem Ipsum Has Been The",
    content: "Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.Donec sed odio dui.",
  },
  {
    imageUrl: "assets/images/blog/blog-comment-three.jpg",
    author: "all the Lorem Ipsum Generator",
    content: "Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.",
  },
];

// blog list data
export const Bloglistdata = [
  {
    title: "lorem ipsum dolor sit amet",
    author: "John Doe",
    date: "1 Oct",
    commentsCount: 25,
    views: 3,
    content: "lorem ipsum dolor sit amet, consecteturamet adipisicing elit, tempor incididunt ut labore. lorem ipsum dolor sit amet.",
    imageUrl: "assets/images/blog/1.jpg",
    detailsLink: `${process.env.PUBLIC_URL}/blog-details`,
  },
  {
    title: "lorem ipsum dolor sit amet",
    author: "John Doe",
    date: "3 Oct",
    commentsCount: 25,
    views: 3,
    content: "lorem ipsum dolor sit amet, consecteturamet adipisicing elit, tempor incididunt ut labore. lorem ipsum dolor sit amet.",
    imageUrl: "assets/images/blog/2.jpg",
    detailsLink: `${process.env.PUBLIC_URL}/blog-details`,
  },
  {
    title: "lorem ipsum dolor sit amet",
    author: "John Doe",
    date: "1 Oct",
    commentsCount: 25,
    views: 3,
    content: "lorem ipsum dolor sit amet, consecteturamet adipisicing elit, tempor incididunt ut labore. lorem ipsum dolor sit amet.",
    imageUrl: "assets/images/blog/3.jpg",
    detailsLink: `${process.env.PUBLIC_URL}/blog-details`,
  },
  {
    title: "lorem ipsum dolor sit amet",
    author: "John Doe",
    date: "5 Oct",
    commentsCount: 25,
    views: 3,
    content: "lorem ipsum dolor sit amet, consecteturamet adipisicing elit, tempor incididunt ut labore. lorem ipsum dolor sit amet.",
    imageUrl: "assets/images/blog/4.jpg",
    detailsLink: `${process.env.PUBLIC_URL}/blog-details`,
  },
  {
    title: "lorem ipsum dolor sit amet",
    author: "John Doe",
    date: "6 Oct",
    commentsCount: 25,
    views: 3,
    content: "lorem ipsum dolor sit amet, consecteturamet adipisicing elit, tempor incididunt ut labore. lorem ipsum dolor sit amet.",
    imageUrl: "assets/images/blog/5.jpg",
    detailsLink: `${process.env.PUBLIC_URL}/blog-details`,
  },
  {
    title: "lorem ipsum dolor sit amet",
    author: "John Doe",
    date: "8 Oct",
    commentsCount: 25,
    views: 3,
    content: "lorem ipsum dolor sit amet, consecteturamet adipisicing elit, tempor incididunt ut labore. lorem ipsum dolor sit amet.",
    imageUrl: "assets/images/blog/6.jpg",
    detailsLink: `${process.env.PUBLIC_URL}/blog-details`,
  },
];


//============= sidebar data =================

export const categories = [
  "Lorem Ipsum is simply",
  "There Are Many Variations",
  "it has survived not five",
  "Lorem Ipsum has been the.",
  "Lorem Ipsum is random."
];

export const tags = [
  "Responsive design", "Color options", "Multiple demos", "Dedicated support",
  "Documentation", "PSD is included", "Text", "Support", "Responsive", "Design"
];

export const recentPosts = [
  {
    image: "assets/images/blog/blog-comment-two.jpg",
    title: "Lorem Ipsum Is Simply Dummy",
    date: "05 March 2011"
  },
  {
    image: "assets/images/blog/blog-comment-three.jpg",
    title: "Lorem Ipsum has been the",
    date: "14 January 2015"
  },
  {
    image: "assets/images/blog/blog-comment.jpg",
    title: "all the Lorem Ipsum Generator",
    date: "30 November 2015"
  }
];

export const blogDetails = {
  title: "There are many variations of passages of Lorem Ipsum available",
  author: "John Doe",
  date: "1 Oct",
  comments: "25 comments",
  views: "3 View",
  content: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
            when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
            It has survived not only five centuries, but also the leap into electronic typesetting, 
            remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset 
            sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like 
            Aldus PageMaker including versions of Lorem Ipsum.`,
  class:'text-decoration-none'
};